import "./styles.scss";
import { observer } from "mobx-react";
import React, { useEffect, useRef } from 'react';
import moment from "moment";
import "moment/locale/ru";
import { UserDashboardWidgetModel } from 'shared/models';
import classnames from 'classnames';

type PropsType = {
    widget: UserDashboardWidgetModel
}

const capitalize = (s: string) =>
    s.charAt(0).toUpperCase() + s.slice(1);

export const PPDWidgetCalendar = observer(({ widget }: PropsType) => {
    moment.locale("ru");

    const days = widget.items;

    const firstDate = moment(days[0].date);
    const monthName = capitalize(firstDate.format("MMMM"));
    const year = firstDate.format("YYYY");
    const todayStr = days.find((d) => d.is_current)?.date || moment().format("YYYY-MM-DD");

    const dayWidth = 28;
    const gap = 0;
    const step = dayWidth + gap;
    const containerRef = useRef<HTMLDivElement>(null)
    const currentIndex = days.findIndex((d) => d.date === todayStr);

    useEffect(() => {
        if (!containerRef.current || currentIndex === -1) return;

        const container = containerRef.current;
        const containerWidth = container.offsetWidth;
        const scrollWidth = days.length * step;

        const currentDayStart = currentIndex * step;

        let targetScroll;
        if (currentIndex >= days.length - 1) {
            targetScroll = scrollWidth - containerWidth;
        } else {
            targetScroll = currentDayStart + dayWidth + gap + dayWidth - containerWidth;
        }

        targetScroll = Math.max(0, Math.min(scrollWidth - containerWidth, targetScroll));

        container.scrollTo({
            left: targetScroll,
        });
    }, [currentIndex, days.length, step, dayWidth, gap]);


    return (
        <div className="ppd-widget-calendar">
            <div className="ppd-widget-calendar__header">
                <div className="ppd-widget-calendar__year">{year}</div>
                <div className="ppd-widget-calendar__month">{monthName}</div>
            </div>

            <div className="ppd-widget-calendar__grid" ref={containerRef}>
                {days.map(day => {
                    const date = moment(day.date);
                    const dayNumber = date.date();
                    const weekday = capitalize(date.format("dd"));
                    const isCurrent = day.date === todayStr;
                    const isWorkday = day.is_workday;
                    const isWeekend = date.day() === 0 || date.day() === 6;

                    return (
                        <div
                            key={day.date}
                            className={
                                classnames("ppd-widget-calendar__cell", {
                                    "ppd-widget-calendar__cell--selected": isCurrent,
                                    "ppd-widget-calendar__cell--weekend": isWeekend
                                })
                            }
                        >
                            <div className="ppd-widget-calendar__day-name">
                                {weekday}
                            </div>
                            <div className="ppd-widget-calendar__day-number">{dayNumber}</div>
                            {isWorkday && (
                                <div className="ppd-widget-calendar__indicator" />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
});
